export default "__VITE_ASSET__DzVoPffC__"